export default __webpack_public_path__ + "static/micacoverv3-985eb6692abd9dd86283d4f4288c42f0.jpg";